import React from "react";
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import AppViews from "views/app-views";
import { Grid, Layout } from "antd";

import navigationConfig from "configs/NavigationConfig";
import { NAV_TYPE_SIDE, NAV_TYPE_TOP } from "constants/ThemeConstant";
import utils from "utils";
import { useTheme } from "../../data/hooks/theme/useTheme";
import { CountriesProvider } from "../../data/hooks/firestore/useCountries";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ location }) => {
  const { navType } = useTheme();
  const currentRouteInfo = utils.getRouteInfo(navigationConfig, location.pathname);
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = !screens.includes("lg");
  const isNavSide = navType === NAV_TYPE_SIDE;
  const isNavTop = navType === NAV_TYPE_TOP;

  return (
    <CountriesProvider>
      <Layout style={{ height: "100vh" }}>
        <HeaderNav isMobile={isMobile} />
        {isNavTop && !isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}
        <Layout className="app-container" style={{ flex: 1, overflow: "hidden" }}>
          {isNavSide && !isMobile ? <SideNav routeInfo={currentRouteInfo} /> : null}
          <Layout className="app-layout" style={{ paddingLeft: 0, flex: 1, display: "flex", flexDirection: "column" }}>
            <div
              className={`app-content ${isNavTop ? "layout-top-nav" : ""}`}
              style={{ flex: 1, overflow: "auto", ...(isMobile && { padding: "8px" }) }}
            >
              <PageHeader display={currentRouteInfo?.breadcrumb} title={currentRouteInfo?.title} />
              <Content>
                <AppViews />
              </Content>
            </div>
            <Footer />
          </Layout>
        </Layout>
        {isMobile && <MobileNav />}
      </Layout>
    </CountriesProvider>
  );
};

export default React.memo(AppLayout);
